import IconWrapper from './IconWrapper.js';
export { default } from './IconWrapper.js';
//# sourceMappingURL=index.js.map
